import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2B2B2B",
      d: "M13.462 6.012 10.275 9.2A4.5 4.5 0 0 0 9 11.75L5.175 7.925a4.46 4.46 0 0 0 2.55-1.275l3.188-3.188zm3.188.638L10.275.275A.904.904 0 0 0 9 .275.904.904 0 0 0 9 1.55l.637.637L6.45 5.375a2.7 2.7 0 0 1-3.825 0L1.35 6.65l3.806 3.806-4.462 4.462v1.275h1.275L6.43 11.73l3.844 3.844L11.55 14.3a2.7 2.7 0 0 1 0-3.825l3.187-3.188.638.638c.35.35.924.35 1.275 0a.904.904 0 0 0 0-1.275"
    }, null, -1)
  ])))
}
export default { render: render }